import React, { Component } from 'react'
import './Footer.styles.css';
export default class Footer extends Component {
  render() {
    return (
      <div className="footer-container">
        <p className="footer-text">© 2019 Waseem Akram - Made with ❤️ in india</p>
      </div>
    )
  }
}
